<div class="footer">
    <div class="link" style="margin-left: 5px;"><a href="https://sblended.com/terms">Terms of Use</a></div>
    <div class="link" style="margin-left: 10px;"><a href="https://sblended.com/privacy">Privacy Policy</a></div>
    <div class="stretch"></div>
    <div style="margin-right: 5px;">©2020 Grixel. All Rights Reserved.</div>
</div>
